export const environment = {
  url: 'https://telemetria.blistertechnologies.net/api',
  socket: 'https://telemetria.blistertechnologies.net',
  prod: false,
};
